/* eslint-disable jsx-a11y/no-onchange */
import React from "react"
import styled from "styled-components"
import axios from "axios"
import { navigate, Link } from "gatsby"
import Img from "gatsby-image"
import { graphql } from "gatsby"
import { v4 } from "uuid"
import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  Section,
  SectionTitle,
  SectionDescription,
  SectionPageTitle,
  BreadCrumb,
  MarkdownContent,
  FormControlLabel,
} from "../components/section"
import CallToAction from "../components/CallToAction"
import RelatedProductCarousel from "../components/RelatedProductCarousel"
import PhoneIcon from "../components/Icons/PhoneIcon"
import QouteIcon from "../components/Icons/QouteIcon"
import DefaultButton from "../components/button/DefaultButton"
import SecondaryButton from "../components/button/SecondaryButton"
import FormButton from "../components/button/FormButton"
import DefaultOutlineButton from "../components/button/DefaultOutlineButton"
import PaymentStep from "../components/PaymentStep"
import FormBg from "../images/form-bg.jpg"
import BreakpointUp from "../components/Media/BreakpointUp"
import Content, { HTMLContent } from "../components/Content"
// import QuotePopup from "../components/QuotePopup"
import PaymentIcon from "../components/Icons/PaymentIcon"
import ProcessIcon from "../components/Icons/ProcessIcon"
import PrePaymentIcon from "../components/Icons/PrePaymentIcon"
import NoCreditIcon from "../components/Icons/NoCreditIcon"
import InterestIcon from "../components/Icons/InterestIcon"
import CreateAccount from "../images/create-account.png"
import ConfirmOffer from "../images/confirm-offer.png"
import GetApproved from "../images/get-approved.png"
import HowEasy from "../images/how-easy.jpg"
import RtoNational from "../images/rto-national.png"
import HfsNational from "../images/hfs-national.png"
import LyonFinancial from "../images/lyon-financial.png"
import PatternBg from "../images/pattern-bg.jpg"

import generateHTML from "../utils/generateHTML"
import QuotePopupModal from "../components/QuotePopupModal"

const TabContainer = styled.div`
  display: block;
  margin-top: 50px;
  ${BreakpointUp.sm`        
    display:flex;
  `}
`
const TabsWrap = styled.div`
  width: 200px;
  margin-right: 30px;
  @media (max-width: 576px) {
    width: 100%;
    display: flex;
    & div {
      width: 50% !important;
    }
  }
`
const TabContentWrap = styled.div`
  width: calc(100% - 230px);
  background: #eee;
  padding: 20px;
  overflow-y: scroll;
  height: 500px;
  @media (max-width: 576px) {
    width: 100%;
    margin-top: 30px;
  }
  img {
    max-width: 60%;
    width: 100%;
  }
  p {
    a {
      display: inline-block;
      text-align: center;
      padding: 12px 24px;
      font-size: 16px;
      font-weight: 700;
      background: #020304;
      border: 1px solid #020304;
      color: #fff;
      position: relative;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      transition-property: color;
      transition-duration: 0.3s;
      &:before {
        content: "";
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
        transform: scaleX(0);
        transform-origin: 0 50%;
        transition-property: transform;
        transition-duration: 0.3s;
        transition-timing-function: ease-out;
      }
      > .text {
        line-height: 20px;
        display: inline-block;
        vertical-align: middle;
      }
      &:hover {
        border-color: #ddd;
        color: #030504;
        &:before {
          transform: scaleX(1);
        }
      }
    }
  }
`
const TabButton = styled.div`
  width: ${props => props.width};
  background: ${props => props.bg};
  border: ${props => props.border};
  box-shadow: ${props => props.boxShadow};
  opacity: ${props => props.opacity};
  padding: 20px;
  &:hover {
    cursor: pointer;
  }
`

const SectionCover = styled.div`
  position:relative;
  .container{
    @media(max-width:991.98px){
      padding:0;
    }
  }
`
const CoverFigure = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  > .gatsby-image-wrapper,
  > img {
    display: inline-block;
    vertical-align: top;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
`
const CoverContent = styled.div`
  position: relative;
  width: 100%;
  @media(min-width:992px){
    padding: 90px 0 0 0;
  }
  @media(min-width:1200px){
    flex: 0 0 50%;
    max-width: 50%;
  }
`
const CoverInner = styled.div`
  background-color:rgba(2,3,4,0.9);
  backdrop-filter: blur(10px);
  padding:30px 20px;
  @media(min-width:768px){
    padding:30px;
  }
  @media(min-width:992px){
    background-color:rgba(2,3,4,0.8);
    padding:50px;
    border-radius:30px 30px 0 0;
  }
`
const ButtonToolbar = styled.div`
  display:flex;
  flex-wrap:wrap;
  margin: 0 -10px;
`
const ButtonToolItem = styled.div`
  position:relative;
  width:100%;
  padding:5px 10px;
  @media(min-width:576px){
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  a, button, .btn{
    display:flex;
    justify-content:center;
    @media(max-width:575.98px){
      width:100%;
    }
  }
  & .cta-btn{
    .btn{
      border-color:#ddd;
    }
  }
  & .btn {
    @media(max-width:575.98px){
      width:100%;
    }
    @media(min-width:768px){
      padding: 15px 30px;
      font-size: 20px;
      line-height: 26px;
    }
  }   
`
const Triangle = styled.div`
  display: ${props => props.display};
  position: relative;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 25px 65px rgba(1, 9, 32, 0.2);
  & :after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    right: -33px;
    box-sizing: border-box;
    border: 0.5em solid;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(-135deg);
    box-shadow: -3px 3px 4px -2px rgba(0, 0, 0, 0.1);
  }
  @media (max-width: 576px) {
    display: none !important;
  }
`
const FinanceService = styled.div`
  margin:30px 0 20px;
`
const FinanceItem = styled.div`
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  .icon{
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    height:28px;
    > svg{
      fill:#fff;
    }
    + .text{
      margin-left:10px;
    }
  }
  .text{
    color:#fff;
    font-size:18px;
    line-height:28px;    
  }
  + .finance-item{
    margin-top:15px;
  }
`
const SectionBkg = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  > .gatsby-image-wrapper, > img {
    display: inline-block;
    vertical-align: top;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  &:after{
    content:'';
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color: rgba(2,3,4,0.9);
  }

`

const Process = styled.div`
  display:flex;
  flex-wrap:wrap;
  margin:0 -15px 10px -15px;
  @media (min-width:992px) {
    margin:0 -15px 20px -15px;
  }
  @media (min-width:1200px) {
    margin:0 -15px 30px -15px;
  }
`
const ProcessItem = styled.div`
  position:relative;
  width:100%;
  padding:0 15px;
  @media (min-width:768px) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
`
const ProcessThumb = styled.div`
    margin-bottom:30px;
  figure{
    margin:0 auto 20px auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  figcaption{
    padding:0;
    font-weight:700;
    text-align:center;
    color: #fff;
    margin:0 auto;
    font-size:18px;
    line-height:28px;
    @media (min-width:768px) {
      max-width:300px;
      font-size:20px;
      line-height:30px;
      width:100%;
    }
    @media (min-width:1200px) {
      font-size:22px;
      line-height:32px;
    }
    @media (min-width:1600px) {
      font-size:24px;
      line-height:34px;
    }
  }
`

const Grid = styled.div`
  position:relative;
  display:flex;
  flex-wrap:wrap;  
  align-items:center;
  box-shadow:0 0 4px rgba(0,0,0,0.4);
  border:1px solid #fff;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  border-radius:20px;
  padding:30px 10px;
  @media (min-width:1200px) {
    padding:40px 20px;
    border-radius:30px;
  }
  @media (min-width:1600px) {
    padding:60px 40px;
    border-radius:40px;
  }
`
const Figure = styled.div`
  display:block;
  margin-bottom:20px;
  min-height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
`
const GridItem = styled.div`
  position:relative;
  padding:30px 15px;
  width:100%;
  text-align:center;
  @media(min-width:768px){
    flex:0 0 33.3333%;
    max-width:33.3333%;
    padding:0 15px;
  }

  + .grid-item{
    @media(max-width:767.98px){
      border-top: 1px solid rgba(0,0,0,0.2);        
    }
  }
  
`

const PatternBkg = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  overflow: hidden;
  > .gatsby-image-wrapper, > img {
    display: inline-block;
    vertical-align: top;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;

    border-radius:30px;
    @media (min-width:1200px) {
      border-radius:40px;
    }
    @media (min-width:1600px) {
      border-radius:60px;
    }
    
  }
`
const FormBgImage = styled.div`
  background-image: ${props => props.bgImg};
  display: block;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(2, 3, 4, 0.9);
  }
`

const FormRow = styled.div`
  display:flex;
  flex-wrap:wrap;
  align-items: center;
  margin: 0 -15px;
  @media(min-width:992px) {	
  }
  @media(min-width:1200px) {
    margin: 0 -30px;
  }
  @media(min-width:1600px) {
    margin: 0 -40px;
  }
`
const FormColumn = styled.div`
  position: relative;
  width:100%;
  padding: 0 15px;
  @media(min-width:992px) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  @media(min-width:1200px) {
    padding: 0 30px;
  }
  @media(min-width:1600px) {
    padding: 0 40px;
  }
  
  `

const FormWrap = styled.div`
  .section-title{
    max-width:550px;
    width:100%;    
    margin:0 0 30px;
    font-size: 20px;
    line-height: 30px;
    @media (min-width: 576px) {
      font-size: 24px;
      line-height: 34px;
    }
    @media (min-width: 768px) {
      font-size: 30px;
      line-height: 40px;
    }
    @media(min-width:992px) {
      font-size: 34px;
      line-height: 44px;
      margin:0 0 60px;    
    }
    @media(min-width:1200px) {
      margin:0 0 80px;    
    }
  }
  .form-group-bordered{
    .form-control{
      border-bottom-color:#ddd;
      color: #fff;
      &:focus{
        border-bottom-color:#fff;
      }
    }
    select.form-control{
      option{
        color:#000;
      }
    }
  }
  
  .form-action{
    .btn{
      border-color:#ddd;
    }
  }

`

const FormGrid = styled.div`
  display: grid;
  align-items: center;
  grid-column-gap: 30px;
  grid-template-columns: repeat(1, 1fr);
  @media(min-width:992px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const Benefits = styled.div`
  margin:0;
`
const BenefitItem = styled.div`
  margin:0;
  + .benefit-item{
    margin-top:20px;
  }
`
const BenefitCard = styled.div`
  background-color:#fff;
  border-radius:30px 0 0;
  padding:20px 15px;
  @media(min-width:768px){
    padding:20px;
  }
  @media(min-width:992px){
    border-radius:40px 0 0;
    padding:30px;
  }
`

const BenefitHeader = styled.div` 
  display:flex;
  flex-wrap:wrap;
  align-items:center;  
  margin-bottom:20px;
  .icon{    
    + .text{
      margin-left:20px;
    }
  }
  .text{
    font-weight:700;
    @media(min-width:992px){
      font-size:24px;
      line-height:34px;
    }
  }
  
`
const BenefitBody = styled.div`
  p{
    margin-bottom:0;
    color:#444;
  }
`


class FinancePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentTab: 0,
      first_name: "",
      email: "",
      mobile_no: "",
      zipcode: "",
      state: "",
      building_type: "",
      comment: "",
      isVisibleQuote: false,
    }
    this.changeTab = this.changeTab.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.showQuote = this.showQuote.bind(this)
    this.onClosePopup = this.onClosePopup.bind(this)
  }
  handleChange(event) {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }
  changeTab(data) {
    this.setState({
      currentTab: data,
    })
  }
  showQuote() {
    this.setState({
      isVisibleQuote: true,
    })
    if (typeof window !== `undefined`) {
      document.querySelector("body").classList.add("modal-open")
    }
  }
  onClosePopup() {
    this.setState({
      isVisibleQuote: false,
    })
    if (typeof window !== `undefined`) {
      document.querySelector("body").classList.remove("modal-open")
    }
  }
  handleSubmit(event) {
    event.preventDefault()
    const { location } = this.props
    const data = {
      source: location.origin,
      form: "Financing Form",
      page: location.pathname,
      first_name: this.state.first_name,
      email: this.state.email,
      mobile_no: this.state.mobile_no,
      state: this.state.state,
      zipcode: this.state.zipcode,
      comment: this.state.comment,
    }
    axios({
      method: "post",
      url: "https://crm.senseicrm.com/api/create-lead-wordpress",
      data: data,
      headers: { Authorization: "Bearer " + process.env.GATSBY_FORM_CRM_TOKEN },
    })
      .then(res => {
        if (typeof dataLayer !== "undefined") {
          window.dataLayer.push({
            event: "form_submit",
            formName: "website_forms",
            enhanced_conversion_data: {
              email: this.state.email,
              phone_number: this.state.mobile_no,
            },
          })
        }
        this.setState({
          first_name: "",
          email: "",
          mobile_no: "",
          state: "",
          zipcode: "",
          building_type: "",
          comment: "",
        })
        navigate("/thanks")
      })
      .catch(error => {
        alert(error)
      })
  }
  render() {
    const { data, location } = this.props
    const pageData = data.contentfulRtoFinancingPage
    // const products = data.allContentfulProduct
    const PostContent = HTMLContent || Content
    const { currentTab } = this.state
    const tabsData = data.contentfulRtoFinancingPage.tabsContent
    const { isVisibleQuote } = this.state

    const products = data.allContentfulProduct
    // let productsData = []
    // productsData = products.edges


    return (
      <Layout location={location} noFinanceSticky>
        <SEO
          title={pageData.metaTitle}
          description={pageData.metaDescription}
        />
        <Section pt="110px" pb="0" xpt="60px" xpb="0">
          <SectionCover>
            <CoverFigure>
              <Img fluid={pageData.heroImage.fluid} />
              {/* <img src={FinanceBanner} alt="Premier Metal Structures" /> */}
            </CoverFigure>
            <div className="container">
              <CoverContent>
                <CoverInner>
                  <BreadCrumb><Link to="/">Home</Link>/ <span>{pageData.url === "/financing" ? "Financing" : "RTO"}</span></BreadCrumb>
                  <SectionPageTitle mb="20px" color="#fff" textAlign="left">{pageData.title}</SectionPageTitle>
                  <MarkdownContent color="#fff">
                    <PostContent content={generateHTML(
                      pageData.heroDescription.childMarkdownRemark.html
                    )}
                    />
                  </MarkdownContent>

                  {pageData.url === "/financing" &&
                    <FinanceService>
                      <FinanceItem className="finance-item">
                        <span className="icon"><PaymentIcon /></span><span className="text">Low-Monthly Payments</span>
                      </FinanceItem>
                      <FinanceItem className="finance-item">
                        <span className="icon"><ProcessIcon /></span><span className="text">Easy Process</span>
                      </FinanceItem>
                      <FinanceItem className="finance-item">
                        <span className="icon"><PrePaymentIcon /></span><span className="text">No Pre-Payment Fees</span>
                      </FinanceItem>
                      <FinanceItem className="finance-item">
                        <span className="icon"><NoCreditIcon /></span><span className="text">No Impact on Credit</span>
                      </FinanceItem>
                      <FinanceItem className="finance-item">
                        <span className="icon"><InterestIcon /></span><span className="text">0% Interest for 2 Years</span>
                      </FinanceItem>
                    </FinanceService>
                  }
                  <ButtonToolbar>
                    <ButtonToolItem>
                      <a href="tel:8776005980" className="cta-btn"><DefaultButton icon={<PhoneIcon />} text="(877) 600-5980" aria-label="phonenumber" /></a>
                    </ButtonToolItem>
                    <ButtonToolItem>
                      <button type="button" className="quote-btn" onClick={this.showQuote}><DefaultOutlineButton icon={<QouteIcon />} text="Apply Now" /></button>
                    </ButtonToolItem>
                  </ButtonToolbar>
                </CoverInner>
              </CoverContent>
            </div>
          </SectionCover>
        </Section>

        <Section pt="60px" pb="60px" xpt="60px" xpb="60px" bg="#f6f6f6">
          <div className="container">
            <SectionTitle maxWidth="750px">{pageData.productSectionTitle}</SectionTitle>
            <SectionDescription maxWidth="1120px">{pageData.productSectionDescription.productSectionDescription}</SectionDescription>
            <RelatedProductCarousel data={products} showQuote={this.showQuote} />
          </div>
        </Section>

        {/* {pageData.url === "/financing" && 
          <Section pt="60px" pb="60px" xpt="60px" xpb="60px" bg="#fff">
            <div className="container">
              <SectionTitle>{pageData.productSectionTitle}</SectionTitle>
              <SectionDescription maxWidth="1120px">{pageData.productSectionDescription.productSectionDescription}</SectionDescription>             
              <ProductCardList
                data={productsData}
                limit="all"
                showQuote = {this.showQuote}
              />
            </div>
          </Section>
        }         */}

        {pageData.url === "/financing" &&
          <Section pt="90px" pb="90px" xpt="60px" xpb="60px" bg="#020304">
            <SectionBkg><img src={HowEasy} alt="Premier Metal Structures" /></SectionBkg>
            <div className="container">
              <SectionTitle color="#fff" mb="30px">How Easy is It?</SectionTitle>
              <Process>
                <ProcessItem>
                  <ProcessThumb>
                    <figure><img src={CreateAccount} alt="Premier Metal Structures" /></figure>
                    <figcaption>Create an account on your device</figcaption>
                  </ProcessThumb>
                </ProcessItem>

                <ProcessItem>
                  <ProcessThumb>
                    <figure><img src={ConfirmOffer} alt="Premier Metal Structures" /></figure>
                    <figcaption>Confirm offer and set up bank info</figcaption>
                  </ProcessThumb>
                </ProcessItem>

                <ProcessItem>
                  <ProcessThumb>
                    <figure><img src={GetApproved} alt="Premier Metal Structures" /></figure>
                    <figcaption>Get approved and start your project</figcaption>
                  </ProcessThumb>
                </ProcessItem>
              </Process>
              <MarkdownContent color="#828181" maxWidth="1120px" textAlign="center">
                <p>*Disclaimer: These loan terms are not guaranteed and are subject to our verification and review process. Applicants may be asked to provide additional documents to enable us to verify their income and their identity. Subsequent charges and fees may increase the cost of the loan. There is no fee or penalty for repaying a loan early. For more information, applicants should refer to the applicable Borrower Agreement and TILA Disclosure.</p>
              </MarkdownContent>
            </div>
          </Section>
        }

        {pageData.url === "/financing" ? (
          <Section pt="90px" pb="90px" xpt="60px" xpb="60px" bg="#fff">
            <div className="container">
              <SectionTitle color="#020304">Available Financing Options</SectionTitle>
              <SectionDescription maxWidth="1130px">
                <p>To bring you the best metal building financing possible, Premier Metal Structures has partnered with RTO National and HFS Financial. This partnership is key to providing you with flexible financing options and ensuring you are able to buy your perfect metal building.</p>
              </SectionDescription>
              <Grid className="grid">
                <PatternBkg><img src={PatternBg} alt="Premier Metal Structures" /></PatternBkg>
                <GridItem className="grid-item">
                  <Figure><img src={RtoNational} alt="Premier Metal Structures" /></Figure>
                  <a href="https://www.rtonational.com/checkout/installment/customer/new?link=73965c59-4977-4d26-b634-b0f2f425b530" className="btn" target="_blank" rel="noreferrer" aria-label="RTO National"><SecondaryButton text="Apply Now" /></a>
                </GridItem>
                <GridItem className="grid-item">
                  <Figure><img src={HfsNational} alt="Premier Metal Structures" /></Figure>
                  <a href="https://www.hfsfinancial.net/promo/6385137eab881a1b5b40b427/" target="_blank" rel="noreferrer" aria-label="HFS" className="btn"><SecondaryButton text="Apply Now" /></a>
                </GridItem>
                <GridItem className="grid-item">
                  <Figure><img src={LyonFinancial} alt="Lyon Financial" /></Figure>
                  <a href="https://www.lyonfinancial.net/apply/?lid=11-21951" target="_blank" rel="noreferrer" aria-label="Lyon Financial" className="btn"><SecondaryButton text="Apply Now" /></a>
                </GridItem>
              </Grid>
            </div>
          </Section>
        ) : (
          <Section pt="90px" pb="90px" xpt="60px" xpb="60px">
            <div className="container">
              <SectionTitle maxWidth="1120px">{pageData.secondSectionTitle}</SectionTitle>
              <TabContainer>
                <TabsWrap>
                  {tabsData.map((item, i) => {
                    return (
                      <TabButton
                        width={currentTab === i ? "100%" : "95%"}
                        opacity={currentTab === i ? "1" : "0.5"}
                        bg={currentTab === i ? "#fff" : "#eee"}
                        border={currentTab === i ? "none" : "1px solid #ddd"}
                        boxShadow={
                          currentTab === i ? "0 5px 20px rgba(0,0,0, .2)" : "none"
                        }
                        onClick={() => this.changeTab(i)}
                        key={v4()}
                      >
                        {item.tabName}
                        <Triangle display={currentTab === i ? "block" : "none"} />
                      </TabButton>
                    )
                  })}
                </TabsWrap>
                <TabContentWrap>
                  {tabsData.map((item, i) => {
                    return (
                      <MarkdownContent
                        display={currentTab === i ? "block" : "none"}
                        key={v4()}
                      >
                        <PostContent
                          content={generateHTML(
                            item.content.childMarkdownRemark.html
                          )}
                        />
                      </MarkdownContent>
                    )
                  })}
                </TabContentWrap>
              </TabContainer>
            </div>
          </Section>
        )}

        <Section pt="90px" pb="90px" xpt="60px" xpb="60px">
          <FormBgImage bgImg={`url(${FormBg})`} />
          <div className="container">
            <SectionTitle color="#fff" maxWidth="890px" mb="30px">{pageData.featuresTitle}</SectionTitle>
            <FormRow>
              <FormColumn>
                <FormWrap>
                  <SectionTitle color="#fff" className="section-title" textAlign="left">{pageData.formTitle}</SectionTitle>
                  <form id="financingform" onSubmit={this.handleSubmit}>
                    <FormGrid>
                      <div className="form-group-bordered">
                        <input
                          type="text"
                          id="first_name"
                          className="form-control"
                          onChange={this.handleChange}
                          required
                        />
                        <FormControlLabel
                          className={
                            this.state.first_name !== ""
                              ? "control-label active"
                              : "control-label"
                          }
                        >
                          Your Full Name
                        </FormControlLabel>
                      </div>
                      <div className="form-group-bordered">
                        <input
                          type="tel"
                          id="mobile_no"
                          className="form-control"
                          pattern="[0-9]{10}"
                          onChange={this.handleChange}
                          required
                        />
                        <FormControlLabel
                          className={
                            this.state.mobile_no !== ""
                              ? "control-label active"
                              : "control-label"
                          }
                        >
                          Phone Number
                        </FormControlLabel>
                      </div>
                    </FormGrid>

                    <div className="form-group-bordered">
                      <input
                        id="email"
                        type="email"
                        className="form-control"
                        onChange={this.handleChange}
                        required
                      />
                      <FormControlLabel
                        className={
                          this.state.email !== ""
                            ? "control-label active"
                            : "control-label"
                        }
                      >
                        Email Address
                      </FormControlLabel>
                    </div>

                    <FormGrid>
                      <div className="form-group-bordered">
                        <input
                          id="zipcode"
                          className="form-control"
                          onChange={this.handleChange}
                          required
                        />
                        <FormControlLabel
                          className={
                            this.state.zipcode !== ""
                              ? "control-label active"
                              : "control-label"
                          }
                        >
                          Zip
                        </FormControlLabel>
                      </div>
                      <div className="form-group-bordered">
                        <select
                          id="state"
                          className="form-control"
                          onChange={this.handleChange}
                        >
                          <option value="" selected="selected">
                            State
                          </option>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District Of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                      </div>
                    </FormGrid>

                    <div className="form-group-bordered">
                      <textarea
                        id="comment"
                        className="form-control"
                        onChange={this.handleChange}
                        required
                      ></textarea>
                      <FormControlLabel
                        className={
                          this.state.comment !== ""
                            ? "control-label active"
                            : "control-label"
                        }
                      >
                        Ask Your Query
                      </FormControlLabel>
                    </div>

                    <div className="form-action">
                      <FormButton text="Submit" />
                    </div>
                  </form>
                </FormWrap>
              </FormColumn>
              <FormColumn>
                <Benefits className="benefits">
                  {pageData.features.map(item => {
                    return (
                      <BenefitItem key={v4()} className="benefit-item">
                        <BenefitCard>
                          <BenefitHeader>
                            <span className="icon"><img src={item.icon} alt={item.title} /></span>
                            <span className="text">{item.title}</span>
                          </BenefitHeader>
                          <BenefitBody>
                            <p>{item.description}</p>
                          </BenefitBody>
                        </BenefitCard>
                      </BenefitItem>
                    )
                  })}
                </Benefits>
              </FormColumn>
            </FormRow>
          </div>
        </Section>

        {pageData.url === "/rto" &&
          <Section pt="90px" pb="90px" xpt="60px" xpb="60px" bg="#F6F6F6">
            <div className="container">
              <SectionTitle maxWidth="550px">
                {pageData.followSectionTitle}
              </SectionTitle>
              <SectionDescription mb="40px">
                {pageData.followSectionDescription.followSectionDescription}
              </SectionDescription>
              <PaymentStep data={pageData.followSteps} />
            </div>
          </Section>
        }

        {pageData.url === "/rto" &&
          <CallToAction sectionData={pageData.ctaSection} />
        }

        <QuotePopupModal
          isVisible={isVisibleQuote}
          onClose={this.onClosePopup}
          location={location}
        />
      </Layout>
    )
  }
}

export default FinancePage

export const pageQuery = graphql`
  query FinancePageQuery($id: String!) {
    contentfulRtoFinancingPage(id: { eq: $id }) {
      metaTitle
      metaDescription
      title
      url
      secondSectionTitle
      heroDescription {
        childMarkdownRemark {
          html
        }
      }
      heroImage {
        fluid {
          aspectRatio
          base64
          src
          srcSet
          srcSetWebp
          srcWebp
        }
      }
      formTitle
      featuresTitle
      features {
        title
        description
        icon
      }
      followSectionTitle
      followSectionDescription {
        followSectionDescription
      }
      followSteps {
        title
        description {
          description
        }
        order
        image {
          fluid {
            aspectRatio
            base64
            src
            srcSet
            srcSetWebp
            srcWebp
          }
        }
      }
      ctaSection {
        sectionTitle
        subTitle
        sectionButtonText
        sectionButtonLink
        sectionImages {
          fluid {
            aspectRatio
            base64
            src
            srcSet
            srcSetWebp
            srcWebp
          }
        }
      }
      productSectionTitle
      productSectionDescription {
        productSectionDescription
      }
      tabsContent {
        tabName
        content {
          childMarkdownRemark {
            html
          }
        }
      }
    }
    allContentfulProduct {
      edges {
        node {
          id
          productName
          url
          popularLabel
          image {
            fluid {
              base64
              aspectRatio
              src
              srcSet
              srcSetWebp
              srcWebp
            }
          }
          width
          height
          length
          totalPrice
          depositPrice
          priceDescription
          featuresImage {
            title
            file {
              url
            }
          }
          productRoof {
            roofName
          }
          productCategory {
            link
          }
        }
      }
    }
  }
`